module.exports = __webpack_public_path__ + "src/assets/img/01_7art_3part.08378506.jpg";